import { Badge, Box, Tab, Tabs } from "@mui/material";
import Icon from "components/icon/icon";
import { useTranslation } from "react-i18next";

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`
  };
}

interface AddressEncodingTabsProps {
  readonly value: number;
  readonly handleChange: (
    event: React.SyntheticEvent,
    newValue: number
  ) => void;
  readonly candidatesDataLength: number;
  readonly noMatchDataLength: number;
  readonly matchDataLength: number;
}

function AddressEncodingTabs({
  value,
  handleChange,
  candidatesDataLength,
  noMatchDataLength,
  matchDataLength
}: AddressEncodingTabsProps) {
  const [t] = useTranslation();

  return (
    <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
      <Tabs
        value={value}
        onChange={handleChange}
        aria-label="basic tabs example"
        textColor="inherit"
        sx={{
          display: "flex",
          justifyContent: "flex-start",
          width: "40%"
        }}
      >
        <Tab
          label={
            <Badge
              badgeContent={candidatesDataLength}
              color={value === 0 ? "error" : "default"}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center"
                }}
              >
                <Icon icon="help" />
                {t("addressEncoding.tab.candidates")}
              </div>
            </Badge>
          }
          {...a11yProps(0)}
          sx={{ flex: 1 }}
        />
        <Tab
          label={
            <Badge
              badgeContent={noMatchDataLength}
              color={value === 1 ? "error" : "default"}
            >
              <Box
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center"
                }}
              >
                <Icon icon="report_problem" />
                {t("addressEncoding.tab.no_match")}
              </Box>
            </Badge>
          }
          {...a11yProps(1)}
          sx={{ flex: 1 }}
        />
        <Tab
          label={
            <Badge
              badgeContent={matchDataLength}
              color={value === 2 ? "error" : "default"}
            >
              <Box
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center"
                }}
              >
                <Icon icon="check_circle" />
                {t("addressEncoding.tab.match")}
              </Box>
            </Badge>
          }
          {...a11yProps(2)}
          sx={{ flex: 1 }}
        />
      </Tabs>
    </Box>
  );
}

export default AddressEncodingTabs;
